import { transformSalesCartItemsResponse } from '../cart/transformers.js';
import { transformCustomerSalesAgent } from '../customer/transformers.js';

const transformPosHeaderAuthRequest = (data, headers)=>{
    headers.isSalesAgentRequest = true;
    headers.CustomerAuthorization = headers.Authorization;
    headers.Authorization = headers.SalesAgentAuthorization;
    return data;
};
const transformPosSalesAgentMeResponse = ({ email , firstname , lastname , studio_photo: companyPhoto , photo , specialization , description , communications , company_name: companyName , vat_number: vatNumber , street , city , zipcode , state , country , telephone , id  })=>({
        id,
        firstname,
        lastname,
        companyPhoto,
        photo,
        email,
        specialization,
        description,
        communications,
        companyName,
        vatNumber,
        street,
        city,
        zipcode,
        state,
        country,
        telephone
    });
const transformPosSalesAgentMeRequest = ({ email , firstname , lastname , companyPhoto: studio_photo , photo , specialization , description , communications , companyName: company_name , vatNumber: vat_number , streetName: street , city , zipcode , state , country , telephone , id  })=>({
        id,
        firstname,
        lastname,
        studio_photo,
        photo,
        email,
        specialization,
        description,
        communications,
        company_name,
        vat_number,
        street,
        city,
        zipcode,
        state,
        country,
        telephone
    });
const transformPosSalesAgentCreateQuoteRequest = ({ name , customerId , quoteDescription: description , quoteAdditionalDescription: description2  })=>({
        name,
        customerId,
        description,
        description2
    });
const transformPosSalesAgentCreateQuoteResponse = ({ entity_id: id , sales_agent_id: salesAgentId , sales_agent_data: salesAgentData , customer_id: customerId , customer_data: customerData , token , name , description: quoteDescription , description2: quoteAdditionalDescription , state , created_at: createdAt , items  })=>({
        id,
        salesAgentId,
        salesAgentData,
        customerId,
        customerData,
        token,
        name,
        quoteDescription,
        quoteAdditionalDescription,
        state,
        createdAt,
        items
    });
const transformPosSalesAgentMeQuotesResponse = ({ count , items  })=>({
        count,
        items: items.map((quote)=>transformQuoteResponse(quote))
    });
const transformPosSalesAgentMeQuoteResponse = (quote)=>transformQuoteResponse(quote);
const transformQuoteResponse = ({ created_at: createdAt , customer_id: customerId , customer_data: customerData , description: quoteDescription , description2: quoteAdditionalDescription , entity_id: id , items , name , sales_agent_data: salesAgentData , state , token  })=>({
        createdAt,
        customerId,
        customerData,
        quoteDescription,
        quoteAdditionalDescription,
        id,
        items: items?.map((item)=>transformSalesCartItemsResponse(item)),
        name,
        salesAgentData: transformCustomerSalesAgent(salesAgentData),
        state,
        token,
        totals: items?.reduce((acc, item)=>acc + item?.price * item?.qty, 0)
    });

export { transformPosHeaderAuthRequest, transformPosSalesAgentCreateQuoteRequest, transformPosSalesAgentCreateQuoteResponse, transformPosSalesAgentMeQuoteResponse, transformPosSalesAgentMeQuotesResponse, transformPosSalesAgentMeRequest, transformPosSalesAgentMeResponse, transformQuoteResponse };
